/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S2_Li3Inputs */

const en_guide_json_schema_s2_li3 = /** @type {(inputs: Guide_Json_Schema_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>properties</strong>: Defines the schema for each property of an object`)
};

const ko_guide_json_schema_s2_li3 = /** @type {(inputs: Guide_Json_Schema_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>properties</strong>: 객체의 각 속성에 대한 스키마를 정의`)
};

const ja_guide_json_schema_s2_li3 = /** @type {(inputs: Guide_Json_Schema_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>properties</strong>: オブジェクトの各プロパティのスキーマを定義`)
};

/**
* | output |
* | --- |
* | "<strong>properties</strong>: Defines the schema for each property of an object" |
*
* @param {Guide_Json_Schema_S2_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s2_li3 = /** @type {((inputs?: Guide_Json_Schema_S2_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S2_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s2_li3(inputs)
	if (locale === "ko") return ko_guide_json_schema_s2_li3(inputs)
	return ja_guide_json_schema_s2_li3(inputs)
});